export type ContractFieldsProps = {
  id: number
  name: string
  archivedAt?: Date | null
}

type GraphQLObject<Name extends string | undefined = string> = {
  __typename?: Name
}

function hasTypename<T extends GraphQLObject, N extends T['__typename']>(
  target: T | undefined | null,
  name: N
) {
  return target?.__typename !== undefined && target.__typename === name
}

export function isGraphQLType<T extends GraphQLObject, N extends T['__typename']>(
  target: T | undefined | null,
  name: N
): target is GraphQLObject<N> & T {
  return hasTypename(target, name)
}
